import React from 'react';
import ceoImage from '../assests/image/me.jpg'

const CEOMessage = () => {
  return (
    <section id="ceo" className="py-20 lg:py-32 bg-white overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        
        {/* 1. HEADING - Now sits on top of everything for mobile */}
        <div className="mb-12 md:mb-16 text-center lg:text-left">
          <span className="text-[#D62828] font-bold uppercase tracking-[0.4em] text-[10px] md:text-sm">Visionary Leadership</span>
          <h2 className="text-4xl md:text-5xl font-black uppercase mt-4 text-[#0A1D37] leading-tight tracking-tighter">
            Message From <br /> <span className="text-[#D62828]">Our Founder</span>
          </h2>
          <div className="h-1.5 w-20 bg-[#0A1D37] mt-6 mx-auto lg:mx-0"></div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          
          {/* 2. IMAGE SIDE - Order 1 on mobile, 1 on desktop */}
          <div className="w-full lg:w-1/2 relative order-1">
            <div className="relative z-20 border-[8px] md:border-[15px] border-gray-100 shadow-2xl bg-[#f8fafc] overflow-hidden rounded-sm">
              <img 
                src={ceoImage} 
                alt="Nauman Ehsan - CEO" 
                className="w-full h-auto object-cover transform hover:scale-105 transition-all duration-700"
                style={{ maxHeight: '500px', objectPosition: 'top' }} 
              />
            </div>
            {/* Decoration blocks hidden on small screens to avoid clutter */}
            <div className="absolute -top-8 -left-8 w-48 h-48 bg-[#D62828]/10 z-10 hidden md:block"></div>
            <div className="absolute -bottom-10 -right-5 w-24 h-3/4 bg-[#0A1D37] z-0 hidden md:block"></div>
          </div>

          {/* 3. TEXT SIDE - Using internal ordering for mobile */}
          <div className="w-full lg:w-1/2 flex flex-col order-2">
            
            {/* 3a. NAME & TITLE - Comes immediately after Image on mobile */}
            <div className="text-center lg:text-left mb-8 order-1 lg:order-2 lg:mt-10">
              <h4 className="text-3xl font-black uppercase text-[#0A1D37]">Nauman Ehsan</h4>
              <p className="text-[#D62828] font-bold uppercase tracking-widest text-[11px] md:text-sm mt-1">
                CEO & Lead Developer, Ehsan Traders
              </p>
            </div>

            {/* 3b. QUOTE & CONTENT - Last on mobile */}
            <div className="relative order-2 lg:order-1">
              <i className="fas fa-quote-left absolute -top-10 -left-6 text-6xl md:text-8xl text-gray-100 z-0 hidden sm:block"></i>
              <div className="relative z-10">
                <p className="text-lg md:text-xl italic text-gray-700 leading-relaxed mb-6 border-l-4 border-[#D62828] pl-6 py-2 text-left">
                  "Technology is the bridge between a vision and its reality. At Ehsan Traders, we build that bridge with precision and passion."
                </p>
                <p className="text-gray-500 leading-relaxed text-base md:text-lg text-left">
                  As a developer and entrepreneur, I understand the balance between clean code and business growth. My goal is to provide software solutions that aren't just functional, but transformative for your brand.
                </p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default CEOMessage;